import { filter, find, first, repeat } from "lodash";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Grid } from "@mui/material";
import { toast } from "react-toastify";

import {
  retrieveAnalista,
  retrieveCarteiras,
  retrieveConvenios,
  retrieveLojasByConvenio,
  retrieveProdutosByGrupo,
  retrieveSituacoes,
  retrieveStatus,
} from "../../../services/frontCredito";
import { cnpjMask, cpfMask, numberMask } from "../../../utils/mask";
import BorderedInputTextCredit from "../../BorderedInputTextCredit";
import Button from "../../ButtonFilter";
import BorderedDatePicker from "../../DatePicker";
import SearchableSelect from "../../SearchableSelect";
import desmaskIfNumber from "../../../utils/desmaskIfNumber";
import { fromUnixTime, getUnixTime } from "date-fns";
import { getInitialState } from "../reducer";
import TimeLeft from "../TimeLeft";
import SearchableMultipleSelect from "../../SearchableMultipleSelect";
import { isValidCPF } from "@brazilian-utils/brazilian-utils";
import isValidCnpj from "../../../utils/isValidCnpj";

const SearchComponent = (props) => {
  const { isLoading, filters, setFilters, setLoadFilter } = props;

  // Combos
  const [convenios, setConvenios] = useState([]);
  const [conveniosDisabled, setConveniosDisabled] = useState(true);
  const [conveniosLoading, setConveniosLoading] = useState(false);

  const [lojas, setLojas] = useState([]);
  const [lojasDisabled, setLojasDisabled] = useState(true);
  const [lojasLoading, setLojasLoading] = useState(false);

  const [carteiras, setCarteiras] = useState([]);
  // const [carteirasDisabled, setCarteirasDisabled] = useState(true);

  const [carteirasDisabled, setCarteirasDisabled] = useState(false);
  const [carteirasLoading, setCarteirasLoading] = useState(false);

  const [produtos, setProdutos] = useState([]);
  const [produtosDisabled, setProdutosDisabled] = useState(true);
  const [produtosLoading, setProdutosLoading] = useState(false);

  const [status, setStatus] = useState("");
  const [statusDisabled, setStatusDisabled] = useState(true);
  const [statusLoading, setStatusLoading] = useState(false);

  const [situacoes, setSituacoes] = useState([]);
  const [situacoesDisabled, setSituacoesDisabled] = useState(true);
  const [situacoesLoading, setSituacoesLoading] = useState(false);

  const [analista, setAnalista] = useState([]);
  const [analistaDisabled, setAnalistaDisabled] = useState(true);
  const [analistaLoading, setAnalistaLoading] = useState(false);

  // Selected filters
  const [selectedCarteira, setSelectedCarteira] = useState(
    filters.selectedCarteira
  );
  const [selectedConvenio, setSelectedConvenio] = useState(
    filters.selectedConvenio
  );
  const [selectedLoja, setSelectedLoja] = useState(filters.selectedLoja);
  const [selectedProduto, setSelectedProduto] = useState(
    filters.selectedProduto
  );
  const [selectedStatus, setSelectedStatus] = useState(filters.selectedStatus);
  const [selectedSituacoes, setSelectedSituacoes] = useState(
    filters.selectedSituacoes
  );
  const [selectedAnalista, setSelectedAnalista] = useState(
    filters.numeroAnalista
  );

  // Typed filters
  const [numeroProposta, setNumeroProposta] = useState(filters.numeroProposta);
  const [pedidoId, setPedidoId] = useState(filters.pedidoId);
  const [numeroCpf, setNumeroCpf] = useState(filters.numeroCpf);
  const [dataInicio, setDataInicio] = useState(filters.dataInicio);
  const [dataFim, setDataFim] = useState(filters.dataFim);

  //Filter ALL
  const [filterAll, setfilterAll] = useState(filters.selectedProduto);
  const [filterAllSituacoes, setfilterAllSituacoes] = useState(
    filters.selectedSituacoes
  );
  const [filterAllAnalista, setfilterAllAnalista] = useState(
    filters.selectedAnalista
  );

  const handleRequest = (action, setData, setDisabled, setLoading, type) => {
    setLoading(true);
    action()
      .then((response) => {
        setData(response.data);
        setDisabled(false);
      })
      .catch(() => console.error(`Error retrieving ${type}`))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    handleRequest(
      () => retrieveConvenios(),
      setConvenios,
      setConveniosDisabled,
      setConveniosLoading,
      "Convenios"
    );
    handleRequest(
      () => retrieveCarteiras(),
      setCarteiras,
      setCarteirasDisabled,
      setCarteirasLoading,
      "Carteiras"
    );
    handleRequest(
      () => retrieveStatus(),
      setStatus,
      setStatusDisabled,
      setStatusLoading,
      "Status"
    );
    handleRequest(
      () => retrieveSituacoes(),
      setSituacoesCustom,
      setSituacoesDisabled,
      setSituacoesLoading,
      "Situacoes"
    );
    handleRequest(
      () => retrieveAnalista(),
      setAnalistaCustom,
      setAnalistaDisabled,
      setAnalistaLoading,
      "Analista"
    );
  }, []);

  useEffect(() => {
    if (selectedConvenio) {
      setLojas([]);
      handleRequest(
        () => retrieveLojasByConvenio(selectedConvenio.codigo),
        setLojas,
        setLojasDisabled,
        setLojasLoading,
        "Lojas"
      );
    }
  }, [selectedConvenio]);

  useEffect(() => {
    if (selectedCarteira) {
      setProdutos([]);
      handleRequest(
        () => retrieveProdutosByGrupo(selectedCarteira.codigo),
        setProdutosCustom,
        setProdutosDisabled,
        setProdutosLoading,
        "Produtos"
      );
    }
  }, [selectedCarteira]);

  const setProdutosCustom = (items) => {
    const objTotal = {
      codigo: "",
      descricao: "TODOS",
      grupo: first(items)?.grupo,
      numeroInstituicao: "",
    };
    items.unshift(objTotal);
    setProdutos(items);
  };

  const setSituacoesCustom = (items) => {
    setSituacoes(items);
    setSelectedSituacoes(
      filter(
        items,
        (item) =>
          find(filters.selectedSituacoes, (it) => it.id === item.id) !==
          undefined
      )
    );
  };

  const setAnalistaCustom = (items) => {
    const objTotal = {
      codigo: "",
      numeroInstituicao: "",
      nome: "TODOS",
      nomeLogin: "",
    };
    items.unshift(objTotal);
    setAnalista(items);
  };

  const clear = () => {
    const initialState = getInitialState();
    setNumeroProposta(initialState.numeroProposta);
    setNumeroCpf(initialState.numeroCpf);
    setPedidoId(initialState.pedidoId);
    setDataInicio(initialState.dataInicio);
    setDataFim(initialState.dataFim);
    setSelectedSituacoes(initialState.selectedSituacoes);
    setSelectedCarteira(initialState.selectedCarteira);
    setSelectedConvenio(initialState.selectedConvenio);
    setSelectedProduto(initialState.selectedProduto);
    setSelectedLoja(initialState.selectedLoja);
    setSelectedStatus(initialState.selectedStatus);
    setSelectedAnalista(initialState.selectedAnalista);
  };
  //TODO: Verificar responsabilidade do Clear
  // Quando limpar o redux, nào limpaa os valores deste componente, não zerando os campos pro usuário.
  // Talvez deva limpar aqui e quando aplicar, voltar pro padrão, mas eu gostaria de deixar o initialState apenas no redux.

  const applyFilters = () => {
    const cleanNumeroCpfOrCnpj = formatarValidarCpfCnpj(numeroCpf);
    if (!cleanNumeroCpfOrCnpj && cleanNumeroCpfOrCnpj !== null) {
      return;
    }

    setLoadFilter(true);
    setFilters({
      page: 0,
      selectedConvenio,
      selectedLoja,
      selectedCarteira,
      selectedProduto,
      selectedStatus,
      selectedSituacoes,
      selectedAnalista,
      numeroProposta,
      pedidoId,
      numeroCpf: cleanNumeroCpfOrCnpj,
      dataInicio,
      dataFim,
    });
  };

  const formatarValidarCpfCnpj = (numeroCpfOrCnpj) => {
    const cleanNumeroCpfOrCnpj =
      numeroCpfOrCnpj && numeroCpfOrCnpj.length > 0
        ? desmaskIfNumber(numeroCpfOrCnpj)
        : null;

    if (
      cleanNumeroCpfOrCnpj &&
      !(isValidCPF(cleanNumeroCpfOrCnpj) || isValidCnpj(cleanNumeroCpfOrCnpj))
    ) {
      toast.error("O número do CPF/CNPJ precisa ser válido.");
      return null;
    }
    return cleanNumeroCpfOrCnpj;
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      applyFilters();
    }
  };

  const getStatusLabel = (status) => {
    return (
      <>
        <StatusSpacer>{repeat("- - - - ", status.level)}</StatusSpacer>
        {status.descricao}
      </>
    );
  };

  return (
    <BoxSearch>
      <Grid container>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={4} lg={3}>
              <BorderedInputTextCredit
                className="textInput"
                label="Proposta"
                placeholder="Insira o número da proposta"
                value={numeroProposta}
                onKeyPress={(e) => handleKeyPress(e)}
                onChange={(e) => {
                  var value = numberMask(e?.target?.value);
                  setNumeroProposta(value);
                }}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <SearchableSelect
                entries={carteiras}
                isDisabled={carteirasDisabled}
                isLoading={carteirasLoading}
                label="Carteira"
                parser={(it) => ({
                  value: it.codigo,
                  label: it.descricao,
                })}
                placeholder="Selecione"
                selected={selectedCarteira}
                setSelected={setSelectedCarteira}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <SearchableSelect
                entries={produtos}
                isDisabled={produtosDisabled}
                isLoading={produtosLoading}
                label="Produto"
                parser={(it) => ({
                  value: it.codigo,
                  label: it.descricao,
                })}
                placeholder="Selecione"
                selected={selectedProduto}
                setSelected={setSelectedProduto}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <BorderedInputTextCredit
                name="cpf"
                type="text"
                className="textInput"
                label="CPF/CNPJ"
                placeholder="Insira o número do CPF ou CNPJ"
                value={numeroCpf}
                onKeyPress={(e) => handleKeyPress(e)}
                onChange={(e) => {
                  var value = (e?.target?.value).replace(/[/.\-]/g, "");
                  const hasLetter = /[A-Za-z]/.test(value);
                  if (!hasLetter && value.length <= 11) {
                    setNumeroCpf(cpfMask(value));
                  } else {
                    setNumeroCpf(cnpjMask(value));
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <SearchableSelect
                entries={convenios}
                isDisabled={conveniosDisabled}
                isLoading={conveniosLoading}
                label="Convênio de Produção"
                parser={(it) => ({ value: it.codigo, label: it.nome })}
                placeholder="Selecione"
                selected={selectedConvenio}
                setSelected={setSelectedConvenio}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <SearchableSelect
                entries={lojas}
                isDisabled={lojasDisabled}
                isLoading={lojasLoading}
                label="Loja"
                parser={(it) => ({
                  value: it.codigoConvenio + "-" + it.codigoFilial,
                  label: it.nomeFilial,
                })}
                placeholder="Selecione"
                selected={selectedLoja}
                setSelected={setSelectedLoja}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <SearchableMultipleSelect
                entries={situacoes.sort((a, b) => (a.id < b.id ? -1 : 1))}
                isDisabled={situacoesDisabled}
                isLoading={situacoesLoading}
                label="Situação"
                parser={(it) => ({
                  value: it.id,
                  label: `${it.id}${it.descricao ? " - " + it.descricao : ""}`,
                })}
                placeholder="Selecione"
                selectedOptions={selectedSituacoes}
                setSelectedOptions={setSelectedSituacoes}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <SearchableSelect
                getCustomLabel={getStatusLabel}
                entries={status}
                isDisabled={statusDisabled}
                isLoading={statusLoading}
                label="Status"
                parser={(it) => ({
                  value: it.numero,
                  label: it.descricao,
                })}
                placeholder="Selecione"
                selected={selectedStatus}
                setSelected={setSelectedStatus}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <BorderedInputTextCredit
                className="textInput"
                label="Pedido"
                placeholder="Insira o número do pedido"
                value={pedidoId}
                onKeyPress={(e) => handleKeyPress(e)}
                onChange={(e) => {
                  var value = numberMask(e?.target?.value);
                  setPedidoId(value);
                }}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <SearchableSelect
                entries={analista}
                isDisabled={analistaDisabled || isLoading}
                isLoading={analistaLoading}
                label="Analista"
                parser={(it) => ({
                  value: it.codigo,
                  label: it.nome,
                })}
                placeholder="Selecione"
                selected={selectedAnalista}
                setSelected={setSelectedAnalista}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <BorderedDatePicker
                label="Data último status inicial"
                selected={fromUnixTime(dataInicio)}
                setSelected={(value) =>
                  value ? setDataInicio(getUnixTime(value)) : ""
                }
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <BorderedDatePicker
                label="Data último status final"
                selected={fromUnixTime(dataFim)}
                setSelected={(value) =>
                  value ? setDataFim(getUnixTime(value)) : ""
                }
              />
            </Grid>
            <TimeLeft reload={applyFilters}></TimeLeft>
            <Grid item xs={12} md={6} lg={8}>
              <ButtonWrapper>
                <Button disabled={isLoading} type="button" onClick={clear}>
                  Limpar
                </Button>
                <Button
                  disabled={isLoading}
                  loading={isLoading}
                  type="button"
                  onClick={applyFilters}
                >
                  Filtrar
                </Button>
              </ButtonWrapper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </BoxSearch>
  );
};

const BoxSearch = styled.div`
  margin: 25px auto;
  border-radius: 7px;
  border: 1px solid gray;
  padding: 24px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: right;
  justify-content: right;
  margin-top: 1rem;
  button {
    margin: 2rem 0 0 2rem;
  }
`;

const StatusSpacer = styled.span`
  color: #000;
  opacity: 0.2;
`;

export default SearchComponent;
